import script from "./RatingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RatingPage.vue?vue&type=script&setup=true&lang=js"

import "./RatingPage.vue?vue&type=style&index=0&id=2c3a332d&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c3a332d"]])

export default __exports__